/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：825
 */

var r = require(/* 168 */"../1648/168")
var o = require(/* 714 */"../1648/714")
var /* [auto-meaningful-name] */$split = "".split
module.exports = r(function () {
  return !Object("z").propertyIsEnumerable(0)
}) ? function (e) {
    return "String" == o(e) ? $split.call(e, "") : Object(e)
  } : Object
